import { format } from "date-fns"

/** Formato que o payment aceita em `startDate`/`endDate` — dia civil, sem hora. */
const API_DATE_FORMAT = "yyyy-MM-dd"

/**
 * Hora usada para reidratar um dia civil vindo da API.
 *
 * `new Date("2026-08-12")` é interpretado como UTC e, em GMT-3, vira 11/08 21:00 —
 * o calendário abriria no dia anterior ao que o operador filtrou. Ancorar ao meio-dia
 * local mantém o dia certo em qualquer fuso do Brasil.
 */
const MIDDAY = "T12:00"

/**
 * Converte a data escolhida no calendário para o parâmetro da API.
 *
 * @param date Data selecionada, no fuso local.
 * @returns O dia civil em `yyyy-MM-dd`.
 */
export const toApiDate = (date: Date): string =>
  format(date, API_DATE_FORMAT)

/**
 * Reidrata um parâmetro `yyyy-MM-dd` da API como data local.
 *
 * @param value Dia civil vindo do filtro; ausente devolve hoje.
 * @returns A data ancorada ao meio-dia local.
 */
export const fromApiDate = (value?: string): Date =>
  value ? new Date(`${value}${MIDDAY}`) : new Date()

/**
 * Recorte inicial do inbox: o dia corrente, como nas demais consultas do portal.
 *
 * @param reference Data de referência — injetável para o teste não depender do relógio.
 * @returns O intervalo de hoje, já no formato da API.
 */
export const todayRange = (
  reference: Date = new Date()
): { startDate: string; endDate: string } => {
  const today = toApiDate(reference)
  return { startDate: today, endDate: today }
}
